import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"text-size"} maskId="square-filled-radius-0-stroke-1-IconTextSize"><path d="M23 4H9V5H15.5V21H16.5V5H23V4Z" fill="currentColor"/><path d="M7.42676 21V11.5H13V10.5L6.42676 10.499L1 10.5V11.5H6.42676V21H7.42676Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTextSize;
